import { alpha, styled } from '@mui/material';

interface ChipStyledProps {
  attrs?: {
    size?: 'small' | 'medium';
  };
}
const ChipStyled = styled('div')<ChipStyledProps>(
  ({ theme, attrs: { size } = {} }) => ({
    width: size === 'small' ? 88 : 178,
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(1),
    fontSize: 14,
  }),
);

export const ChipSuccessStyled = styled(ChipStyled)(({ theme }) => ({
  background: alpha(theme.palette.secondary.main, 0.16),
  color: theme.palette.secondary.main,
}));

export const ChipDangerStyled = styled(ChipStyled)(({ theme }) => ({
  background: alpha(theme.palette.error.main, 0.16),
  color: theme.palette.error.main,
}));
export const ChipWarningStyled = styled(ChipStyled)(({ theme }) => ({
  background: theme.palette.warning.main,
  color: theme.palette.white.main,
}));
export const ChipPurpleStyled = styled(ChipStyled)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.white.main,
}));
